// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const creditDomainDto = {
    domainGuid: 'domainGuid',
    name: 'name',
    deleted: 'deleted',
    ownerGuid: 'ownerGuid',
    ownerName: 'ownerName',
    ownerEmail: 'ownerEmail',
    creditBalance: 'creditBalance',
    creditLimit: 'creditLimit',
    billingGraceUntil: 'billingGraceUntil',
    forecast: 'forecast',
    available: 'available',
    discountOwner: 'discountOwner',
    discountFunctions: 'discountFunctions',
    discountMembers: 'discountMembers',
    storageDay: 'storageDay',
    storageBytes: 'storageBytes',
    storagePeakBytes: 'storagePeakBytes',
    billingState: 'billingState',
    billingStateSince: 'billingStateSince',
    cleanupFrom: 'cleanupFrom',
} as const;

export type TCreditDomainDto = (typeof creditDomainDto)[keyof typeof creditDomainDto];

export interface ICreditDomainDto {
    [creditDomainDto.domainGuid]: string | null;
    [creditDomainDto.name]: string | null;
    [creditDomainDto.deleted]: boolean | null;
    [creditDomainDto.ownerGuid]: string | null;
    [creditDomainDto.ownerName]: string | null;
    [creditDomainDto.ownerEmail]: string | null;
    [creditDomainDto.creditBalance]: number | null;
    [creditDomainDto.creditLimit]: number | null;
    [creditDomainDto.billingGraceUntil]: string | null;
    [creditDomainDto.forecast]: number | null;
    [creditDomainDto.available]: number | null;
    [creditDomainDto.discountOwner]: number | null;
    [creditDomainDto.discountFunctions]: number | null;
    [creditDomainDto.discountMembers]: number | null;
    [creditDomainDto.storageDay]: string | null;
    [creditDomainDto.storageBytes]: number | null;
    [creditDomainDto.storagePeakBytes]: number | null;
    [creditDomainDto.billingState]: string | null;
    [creditDomainDto.billingStateSince]: string | null;
    [creditDomainDto.cleanupFrom]: string | null;
}

export class CreditDomainDto
    implements ICreditDomainDto
{
    [creditDomainDto.domainGuid]: string | null = null;
    [creditDomainDto.name]: string | null = null;
    [creditDomainDto.deleted]: boolean | null = null;
    [creditDomainDto.ownerGuid]: string | null = null;
    [creditDomainDto.ownerName]: string | null = null;
    [creditDomainDto.ownerEmail]: string | null = null;
    [creditDomainDto.creditBalance]: number | null = null;
    [creditDomainDto.creditLimit]: number | null = null;
    [creditDomainDto.billingGraceUntil]: string | null = null;
    [creditDomainDto.forecast]: number | null = null;
    [creditDomainDto.available]: number | null = null;
    [creditDomainDto.discountOwner]: number | null = null;
    [creditDomainDto.discountFunctions]: number | null = null;
    [creditDomainDto.discountMembers]: number | null = null;
    [creditDomainDto.storageDay]: string | null = null;
    [creditDomainDto.storageBytes]: number | null = null;
    [creditDomainDto.storagePeakBytes]: number | null = null;
    [creditDomainDto.billingState]: string | null = null;
    [creditDomainDto.billingStateSince]: string | null = null;
    [creditDomainDto.cleanupFrom]: string | null = null;

    private constructor(
        modelData: any, // TODO: vervang door ICreditDomainData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[creditDomainDto.guid] = modelData[creditdomainData.guid];
    }

    static create(modelData?: any | null): ICreditDomainDto | null {
        return modelData ? new CreditDomainDto(modelData) : null;
    }
}
